import React, { forwardRef } from 'react';
import './AsyncButton.css';

export interface AsyncButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: React.ReactNode;
}

const AsyncButton = forwardRef<HTMLButtonElement, AsyncButtonProps>(
  function AsyncButton(
    {
      loading = false,
      loadingText = 'Processing...',
      disabled,
      className,
      children,
      ...buttonProps
    },
    ref,
  ) {
    return (
      <button
        {...buttonProps}
        ref={ref}
        className={['async-button', className].filter(Boolean).join(' ')}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        data-loading={loading ? 'true' : undefined}>
        <span className="async-button__sizer">
          <span
            className="async-button__content"
            aria-hidden={loading || undefined}>
            {children}
          </span>
          <span
            className="async-button__loading"
            aria-hidden={!loading || undefined}>
            {loadingText}
          </span>
        </span>
      </button>
    );
  },
);

export default AsyncButton;
